import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import NotFoundPage from "$src/core/pages/NotFoundPage/NotFoundPage";

const Route: React.FC = () => (
  <PageLayout>
    <NotFoundPage />
  </PageLayout>
);

export default Route;
